module.exports = __webpack_public_path__ + "static/img/why-3.58cd69d3.jpg";